import { createFileRoute } from "@tanstack/react-router";
import { RadioFeaturePage } from "@/components/landing/MissionReadyPublicSite";
import { socialMeta } from "@/lib/social-meta";
import { SITE_URL } from "@/lib/structured-data";

const TITLE = "Push-to-Talk Radio for Security Teams | MissionReady";
const DESCRIPTION =
  "Hold to talk to every officer on your site. Live audio powered by LiveKit, transcripts by Deepgram, saved to a searchable site Radio thread — no audio stored.";

export const Route = createFileRoute("/radio-ptt")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      ...socialMeta({ title: TITLE, description: DESCRIPTION, url: `${SITE_URL}/radio-ptt` }),
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/radio-ptt` }],
  }),
  component: RadioFeaturePage,
});
